export default "__VITE_ASSET__MwtHUvLo__"